module.exports = __webpack_public_path__ + "img/img_platform_name_a.94fbcb45.png";